/* eslint-disable react-hooks/exhaustive-deps */
import { Stack } from "@chakra-ui/react";
import React from "react";
import DataTables from "../../../components/Datatable";
import { getDirectBondsMembershipsAsync } from "../../../redux/range/actions";
import { Edit } from "./edit";

export const DirectBondMemberships = () => {
  const selectable = (state) => state.range.directBondsMemberships;

  const columns = (row) => {
    return {
      Nivel_de_profundidad: row.level,
      Porcentaje: row.bond,
      opciones: (
        <div>
          <Edit bond={row} />
        </div>
      ),
    };
  };

  const dispatchable = (query) => {
    return getDirectBondsMembershipsAsync({
      ...query,
    });
  };

  return (
    <Stack style={{ display: "flex", flexDirection: "row" }} bg={"white"}>
      <DataTables
        columns={columns}
        dispatchable={dispatchable}
        selectable={selectable}
        title="Bono directo membresías"
      />
    </Stack>
  );
};
